import React from 'react'
import Plot from 'react-plotly.js'
import { Card, CardContent, Typography } from '@mui/material'
import { Icon as IconifyIcon } from "@iconify/react"
import './ConflictingGenesChart.scss'

export default function ConflictingGenesChart({ data }) {
    if (!data || data.length === 0) {
        return (
            <Card className="conflicting-genes-chart-card">
                <CardContent>
                    <Typography variant="h6" className="chart-title">
                        <IconifyIcon icon="mdi:dna" className="title-icon" />
                        Gene mit Konflikten
                    </Typography>
                    <Typography variant="body2" color="textSecondary" className="no-data-message">
                        Keine Gene mit Konflikten gefunden
                    </Typography>
                </CardContent>
            </Card>
        )
    }

    // Prepare data for horizontal bar chart
    const genes = data.map(g => g.gene)
    const conflicts = data.map(g => g.conflicts)

    const plotData = [{
        y: genes,
        x: conflicts,
        type: 'bar',
        orientation: 'h',
        marker: {
            color: '#d32f2f',
            opacity: 0.8
        },
        hovertemplate: '<b>%{y}</b><br>%{x} Konflikte<extra></extra>',
        text: conflicts,
        textposition: 'outside',
        textfont: {
            size: 11,
            color: '#666'
        }
    }]

    const layout = {
        title: {
            text: 'Top Gene mit Klassifikations-Konflikten',
            font: {
                size: 16
            }
        },
        height: 400,
        margin: {
            l: 100,
            r: 50,
            t: 60,
            b: 50
        },
        xaxis: {
            title: 'Anzahl Konflikte',
            gridcolor: '#e0e0e0',
            showgrid: true
        },
        yaxis: {
            title: '',
            automargin: true,
            tickfont: {
                size: 12,
                family: 'monospace'
            }
        },
        paper_bgcolor: 'white',
        plot_bgcolor: 'white',
        hovermode: 'closest'
    }

    const config = {
        responsive: true,
        displayModeBar: false
    }

    return (
        <Card className="conflicting-genes-chart-card">
            <CardContent>
                <div className="chart-header">
                    <Typography variant="h6" className="chart-title">
                        <IconifyIcon icon="mdi:dna" className="title-icon" />
                        Gene mit Konflikten
                    </Typography>
                    <Typography variant="caption" color="textSecondary" className="chart-subtitle">
                        Ähnlich zu Fokkema et al. Tabelle 2 - Gene mit den meisten P/LP vs. B/LB Konflikten
                    </Typography>
                </div>
                <Plot
                    data={plotData}
                    layout={layout}
                    config={config}
                    className="genes-plot"
                    style={{ width: '100%' }}
                />
                <div className="chart-note">
                    <Typography variant="caption" color="textSecondary">
                        <strong>Hinweis:</strong> Diese Gene erfordern besondere Aufmerksamkeit bei der Interpretation,
                        möglicherweise aufgrund niedriger Penetranz oder verzögertem Krankheitsbeginn.
                    </Typography>
                </div>
            </CardContent>
        </Card>
    )
}
